<template>
  <BCard>
    <BRow>
      <BCol cols="12"> <h4 class="mb-2">{{$t('General data')}}</h4> </BCol>
    </BRow>
    <BRow>

      <!-- Customer Info: Left col -->
      <BCol cols="12" xl="6" >
        <table class="mt-2 mt-xl-0 w-100">
          <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="userData.full_name" />
          <ViewData vsIcon="UserIcon" vsLabel="Username" :vsValue="userData.username" />
          <ViewData vsIcon="ShieldIcon" vsLabel="Rol" :vsValue="userData.roles[0].name" />
        </table>
      </BCol>

      <!-- Right Col: Table -->
      <BCol cols="12" xl="6" >
        <table class="mt-2 mt-xl-0 w-100">
          <ViewData vsIcon="MailIcon" vsLabel="Email" :vsValue="userData.email" />
          <ViewData vsIcon="UserCheckIcon" vsLabel="Status" :vsValue="userData.status" vsCheckbox />
          <tr>
            <th class="pb-50"> <feather-icon icon="HomeIcon" class="mr-75" /> <span class="font-weight-bold">{{$t('Groups')}}</span> </th>
            <td class="pb-50"> <span v-for="(group, index) in userData.groups" :key="group.id"> {{ index+1 != userData.groups.length ? group.name + ' | ' : group.name }}  </span> </td>
          </tr>
        </table>
      </BCol>

    </BRow>
  </BCard>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import useUsersList from '../users-list/useUsersList'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormCheckbox,
    ViewData
},
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      resolveUserRoleVariant,
      ability,
    }
  },
}
</script>

<style>

</style>
